import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import UICounter from "@components/counter";

import styles from "./Counter.scss";

const cx = classnames.bind(styles);

const Counter = ({
  children,
  active,
  className,
  maxValue,
  size,
  "data-name": dataName = "counter",
}) => (
  <UICounter
    className={cx(active ? "active-counter" : "counter", className)}
    data-name={dataName}
    maxValue={maxValue}
    active={active}
    size={size}
  >
    {children}
  </UICounter>
);

Counter.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  className: PropTypes.string,
  maxValue: PropTypes.number,
  "data-name": PropTypes.string,
  size: PropTypes.oneOf(["medium", "small"]),
};

export default Counter;
